<div *ngIf="config.title" class="header">
  <button (click)="dismissPopup()" *ngIf="config.showCloseButton" class="popup-close-button" tabindex="0"></button>
  <h2 class="title">{{config.title}}</h2>
</div>

<div class="body">
  <ng-container *ngIf="config.description">
     <div class="description">{{config.description}}</div>
     <div *ngIf="config.subDescription" class="description sub">{{config.subDescription}}</div>
  </ng-container>

  <ng-container *ngIf="config.template && config.context">
    <ng-container *ngTemplateOutlet="config.template; context: config.context"></ng-container>
  </ng-container>
</div>

<div *ngIf="!config.hideActions" [ngClass]="config.hideCancelAction || config.hideSaveAction ? 'center-one-btn': ''"
     class="button-block">
  <button (click)="close()" *ngIf="!config.hideCancelAction"
          class="page-button button-link body-link">{{cancelBtnTitle}}</button>
  <button (click)="save()" *ngIf="!config.hideSaveAction"
          class="page-button button-link body-link">{{saveBtnTitle}}</button>
</div>
